import { forwardRef, useEffect, useState } from "react";
import { dateFnsLocale } from "../../../lib/date_fns_locale";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Icon from "../../Icon";
import styles from "./DateSelector.module.css";
import { useAdjustFrameForPopup } from "../../../lib/use_autosize";

interface DateSelectorProps {
  className?: string;
  dateFormat?: string;
  onChange: (date: Date | null) => void;
  value?: Date | null;
}

function DateSelector({
  className,
  dateFormat,
  onChange,
  value,
}: DateSelectorProps): JSX.Element | null {
  const [calenderOpen, setCalenderOpen] = useState<boolean | number>(false);
  useAdjustFrameForPopup({
    isShown: calenderOpen,
    popupQuery: ".react-datepicker",
    extraHeight: 25,
    fullPage: true,
    label: "datepicker",
  });

  // Need to massage the incoming "DD","MM", "YY" into our format.
  dateFormat ||= "P";
  dateFormat = dateFormat
    .replace(/D+/gi, "d")
    .replace(/M+/gi, "M")
    .replace(/Y+/gi, "yyyy");

  const CustomInput = forwardRef<HTMLButtonElement>((inputProps, ref) => {
    /* eslint-disable */
    return (
      <button
        aria-label="Open calendar"
        {...inputProps}
        type="button"
        className={`w-40 cursor-pointer text-xl px-3 pl-3 py-2 flex items-center ${
          className ? className : ""
        } rounded`}
        ref={ref}
      >
        <Icon type="calendar" className="h-5 w-5 mr-3" aria-hidden="true" />
        <span className="relative top-[1px]">{inputProps.value}</span>
      </button>
    );
    /* eslint-enable */
  });

  return (
    <div className={`${styles.dateSelector} font-number`}>
      <DatePicker
        customInput={<CustomInput />}
        dateFormat={dateFormat}
        fixedHeight
        locale={dateFnsLocale(window.language)}
        minDate={new Date()}
        selected={value}
        onChange={onChange}
        onCalendarClose={() => setCalenderOpen(false)}
        onCalendarOpen={() => setCalenderOpen(true)}
        onMonthChange={() => setCalenderOpen(Date.now())}
        popperPlacement="auto"
        popperModifiers={[
          {
            name: "preventOverflow",
            options: {
              altAxis: true,
              padding: 20,
            },
          },
        ]}
      />
    </div>
  );
}

export default DateSelector;
